/**
 * Update the classes of a specific scrollbox.
 */
const researchIntegrationUpdateScrollBoxClasses = function($scrollbox) {
  const $container = $scrollbox.find('.scrollbox-container');
  const $content = $container.find('.scrollbox-content');
  if ($container.length == 0 || $content.length == 0) {
    return;
  }

  if ($container.scrollLeft() == 0) {
    // No scroll.
    if ($content.outerWidth() <= $container.width()) {
      $scrollbox.removeClass('right-border left-border');
    } else {
      $scrollbox.addClass('right-border');
      $scrollbox.removeClass('left-border');
    }
  } else {
    // Scrolled.
    if ($container.scrollLeft() < Math.floor($content.outerWidth() - $container.width())) {
      $scrollbox.addClass('right-border left-border');
    } else {
      $scrollbox.removeClass('right-border');
      $scrollbox.addClass('left-border');
    }
  }
}

/**
 * Enable scrollboxes for wide content.
 */
const researchIntegrationEnableScrollboxes = function() {
  $('.research-integration').find('.scrollbox').each(function(index, el) {
    const $scrollbox = $(el);
    $scrollbox.html('<div class="scrollbox-container"><div class="scrollbox-content">' + $(el).html() + '</div></div>');

    $scrollbox.find('.scrollbox-container').scroll(function(event) {
      researchIntegrationUpdateScrollBoxClasses($scrollbox);
    });
    $(window).resize(function(event) {
      researchIntegrationUpdateScrollBoxClasses($scrollbox);
    });
    researchIntegrationUpdateScrollBoxClasses($scrollbox);
  });
}

export {
  researchIntegrationUpdateScrollBoxClasses,
  researchIntegrationEnableScrollboxes
};